import script from "./organization-index.vue?vue&type=script&setup=true&lang=js"
export * from "./organization-index.vue?vue&type=script&setup=true&lang=js"

import "./organization-index.vue?vue&type=style&index=0&id=c81c1110&lang=css"

const __exports__ = script;

export default __exports__